export enum FeatureFlag {
	SfauthEnableIdentityPilet = 'sfauth-enable-identity-pilet',
	EnableRefactoredMFA = 'enable_refactored_mfa',
	SessionEnabled = 'sfauth_enable_session_mgmt_pilet',
	EnableOTP = 'enable_otp',
}
